import type { ReactNode } from 'react';

/**
 * A labelled form field: the small-caps label over its control, with any note
 * or count under it as children (`.field`, styles/forms.css).
 */
export function Field({
  label,
  htmlFor,
  children,
}: {
  label: ReactNode;
  htmlFor: string;
  children: ReactNode;
}) {
  return (
    <div className="field">
      <label className="label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
    </div>
  );
}
